<template>
    <img
        v-if="showImage"
        :src="url"
        :alt="alt"
        @error.native="hasError = true"/>
</template>

<script>

export default {

    name: "Image",

    props: {
        url: String,
        alt: String,
        fallback: String,
    },

    data() {
        return {
            hasError: false,
        }
    },

    computed: {
        showImage() {
            return !!this.url && !this.hasError;
        },
    },
};

</script>
